import type { X402Endpoint } from "@/hooks/useX402Endpoints";
import { apexSlug } from "./providerSlug";

export function groupEndpointsByProvider(endpoints: X402Endpoint[]): Record<string, X402Endpoint[]> {
  const grouped: Record<string, X402Endpoint[]> = {};
  for (const endpoint of endpoints) {
    const slug = apexSlug(endpoint.baseUrl);
    if (!grouped[slug]) grouped[slug] = [];
    grouped[slug].push(endpoint);
  }
  return grouped;
}
